import img1 from '../images/slider/gangster.png';
import img2 from '../images/slider/bully.png';
import imgbg1 from '../images/slider/bg_slide_1.png'
import imgbg2 from '../images/slider/bg_slide_1.png'


const heroSliderData = [{
        title_1: "Collect, Trade, Buy &",
        title_2: "Sell extraordinary",
        title_3: "VeChain NFTs",
        description: "BlackVeMarket, the people's Marketplace. ",
        img: img1,
        imgbg: imgbg1
    },
    {
        title_1: "Collect, Trade, Buy &",
        title_2: "Sell extraordinary",
        title_3: "VeChain NFTs",
        description: "BlackVeMarket, the people's Marketplace. ",
        img: img2,
        imgbg: imgbg2
    },

]

export default heroSliderData;